import script from "./CompanyPayloadView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyPayloadView.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyPayloadView.vue?vue&type=style&index=0&id=af7b1db6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af7b1db6"]])

export default __exports__